const ADDON_STORAGE_KEY = 'pdpMandatoryAddons';

function getMandatoryAddonMappings() {
  try {
    return JSON.parse(localStorage.getItem(ADDON_STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function saveMandatoryAddonMappings(mappings) {
  localStorage.setItem(ADDON_STORAGE_KEY, JSON.stringify(mappings));
}

document.addEventListener('cart:item-add', () => {
  const productForm = document.querySelector('product-form[data-mandatory-addons]');
  if (!productForm) return;

  const addonsRaw = productForm.dataset.mandatoryAddons;
  if (!addonsRaw) return;

  const variantIds = addonsRaw
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

  if (!variantIds.length) return;

  const mainVariantInput = productForm.querySelector('[name="id"]');
  const mainVariantId = mainVariantInput ? parseInt(mainVariantInput.value, 10) : null;
  if (mainVariantId) {
    const mappings = getMandatoryAddonMappings();
    mappings[mainVariantId] = variantIds.map((id) => parseInt(id, 10));
    saveMandatoryAddonMappings(mappings);
  }

  const items = variantIds.map((id) => ({ id: parseInt(id, 10), quantity: 1 }));

  fetch(`${window.routes.cart_add_url}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({ items }),
  })
    .then((res) => res.json())
    .then(() => {
      const miniCart = document.querySelector('mini-cart');
      if (miniCart && typeof miniCart.updateSectionContents === 'function') {
        miniCart.updateSectionContents();
      }
    })
    .catch((err) => console.error('[pdp-extras] Failed to add mandatory addons:', err));
});

let pendingRemoveVariantId = null;

document.addEventListener(
  'click',
  (e) => {
    const removeBtn = e.target.closest('cart-remove-button');
    if (!removeBtn) return;
    pendingRemoveVariantId = parseInt(removeBtn.dataset.variantId, 10) || null;
  },
  true,
);

document.addEventListener(
  'change',
  (e) => {
    const input = e.target.closest('input[name="updates[]"][data-variant-id]');
    if (!input) return;
    if (parseInt(input.value, 10) === 0) {
      pendingRemoveVariantId = parseInt(input.dataset.variantId, 10) || null;
    }
  },
  true,
);

document.addEventListener('cart:item-remove', () => {
  const removedId = pendingRemoveVariantId;
  pendingRemoveVariantId = null;

  if (!removedId) return;

  const mappings = getMandatoryAddonMappings();
  const addons = mappings[removedId];
  if (!addons || !addons.length) return;

  delete mappings[removedId];
  saveMandatoryAddonMappings(mappings);

  const updates = {};
  addons.forEach((id) => {
    updates[id] = 0;
  });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({ updates }),
  })
    .then((res) => res.json())
    .then((cart) => {
      const miniCart = document.querySelector('mini-cart');
      if (miniCart && typeof miniCart.updateSectionContents === 'function') {
        miniCart.updateSectionContents();
      }

      const cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.updateSectionContents === 'function') {
        cartItems.updateSectionContents().then(() => {
          if (cart.item_count === 0) {
            cartItems.classList.add('is-empty');
          }
        });
      }
    })
    .catch((err) => console.error('[pdp-extras] Failed to remove mandatory addons:', err));
});

const ROUTE_SKU = 'ROUTEINS';

function refreshCartSections(isEmpty) {
  const renders = [];

  const miniCart = document.querySelector('mini-cart');
  if (miniCart && typeof miniCart.updateSectionContents === 'function') {
    renders.push(miniCart.updateSectionContents());
  }
  const cartItems = document.querySelector('cart-items');
  if (cartItems && typeof cartItems.updateSectionContents === 'function') {
    renders.push(cartItems.updateSectionContents());
  }

  return Promise.all(renders).then(() => {
    if (cartItems) cartItems.classList.toggle('is-empty', isEmpty);
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);
    const miniCartFooter = document.getElementById('header-mini-cart-footer');
    if (miniCartFooter) miniCartFooter.hidden = false;
  });
}

let routeCleanupInFlight = false;

function removeRouteLines(onlyIfAlone) {
  if (routeCleanupInFlight) return Promise.resolve();
  routeCleanupInFlight = true;

  return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then((res) => res.json())
    .then((cart) => {
      const routeLines = cart.items.filter((line) => line.sku === ROUTE_SKU);
      const nonRouteCount = cart.items.length - routeLines.length;

      if (routeLines.length === 0) return;
      if (onlyIfAlone && nonRouteCount > 0) return;

      const updates = {};
      routeLines.forEach((line) => {
        updates[line.key] = 0;
      });

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ updates }),
      })
        .then((res) => res.json())
        .then((updatedCart) => refreshCartSections(updatedCart.item_count === 0));
    })
    .catch((err) => console.error('[pdp-extras] Route cleanup failed:', err))
    .finally(() => {
      routeCleanupInFlight = false;
    });
}

function showEmptyIfOnlyRouteLeft(event) {
  const cart = event.detail && event.detail.cart;
  if (!cart || !Array.isArray(cart.items)) return;
  const onlyRouteLeft =
    cart.items.length > 0 && cart.items.every((line) => line.sku === ROUTE_SKU);
  if (!onlyRouteLeft) return;

  const cartItems = document.querySelector('cart-items');
  if (cartItems) cartItems.classList.add('is-empty');
  const cartFooter = document.getElementById('main-cart-footer');
  if (cartFooter) cartFooter.classList.add('is-empty');

  const miniCartContent = document.getElementById('header-mini-cart-content');
  if (miniCartContent) {
    miniCartContent.innerHTML =
      '<div class="mini-cart-route-clearing"><span class="spinner"></span></div>';
  }
  const miniCartFooter = document.getElementById('header-mini-cart-footer');
  if (miniCartFooter) miniCartFooter.hidden = true;
}

function handleCartLineChange(event) {
  showEmptyIfOnlyRouteLeft(event);
  removeRouteLines(true);
}

document.addEventListener('cart:item-remove', handleCartLineChange);
document.addEventListener('cart:item-quantity-update', handleCartLineChange);
document.addEventListener('DOMContentLoaded', () => removeRouteLines(true));
document.addEventListener('click', (e) => {
  const removeBtn = e.target.closest('[data-route-remove]');
  if (!removeBtn) return;
  e.preventDefault();
  removeRouteLines(false);
});

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('[data-type="add-to-cart-form"]');
  if (!form) return;

  const vehicleYearField = form.querySelector('.product-vehicle-year');
  if (!vehicleYearField) return;

  const input = vehicleYearField.querySelector('input[name="properties[Vehicle Year]"]');
  if (!input) return;

  form.addEventListener(
    'submit',
    (event) => {
      const value = input.value.trim();
      const isValid = /^\d{4}$/.test(value) && parseInt(value, 10) >= 1900;

      vehicleYearField.classList.toggle('has-error', !isValid);

      if (!isValid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.focus();
      } else {
        vehicleYearField.classList.remove('has-error');
      }
    },
    { capture: true },
  );

  input.addEventListener('input', () => {
    vehicleYearField.classList.remove('has-error');
  });
});

(function () {
  const IFRAME_ID = 'gw-stock-fulfilled-iframe';

  const INJECTED_CSS = `
    .modal-container {
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
      background-color: #ffffff !important;
      color: #272725 !important;
      padding: 32px 28px 24px !important;
      border-radius: 12px !important;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
      max-width: 520px !important;
      width: calc(100% - 40px) !important;
      margin: 0 auto !important;
      box-sizing: border-box !important;
      border-color: #fff !important;
    }

    .modal-title {
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
      font-size: 18px !important;
      font-weight: 700 !important;
      color: #272725 !important;
      text-transform: uppercase !important;
      letter-spacing: 0.05em !important;
      margin: 0 0 10px !important;
      padding-right: 28px !important;
      line-height: 1.3 !important;
    }

    .notification-message {
      font-size: 14px !important;
      color: #272725 !important;
      margin: 0 0 20px !important;
      line-height: 1.5 !important;
    }

    .email-input {
      display: block !important;
      width: 100% !important;
      box-sizing: border-box !important;
      height: 48px !important;
      padding: 8px 16px !important;
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
      font-size: 14px !important;
      color: #272725 !important;
      background-color: #ffffff !important;
      border: 1px solid rgba(0, 0, 0, 0.2) !important;
      border-radius: 8px !important;
      outline: none !important;
      transition: border-color 0.18s ease, box-shadow 0.18s ease !important;
      margin-bottom: 16px !important;
    }
    .email-input:hover,
    .email-input:focus {
      border-color: #f1684a !important;
    }
    .email-input::placeholder {
       color: #272725;
    }

    .notify-button {
      background-color: #f1684a !important;
      border: none !important;
      outline: none !important;
      color: #ffffff !important;
      border-radius: 10px !important;
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
      font-weight: 600 !important;
      font-size: 15px !important;
      padding: 12px 28px !important;
      letter-spacing: 0.02em !important;
      cursor: pointer !important;
      transition: background-color 0.18s ease !important;
      min-width: 140px !important;
    }
    .notify-button:hover,
    .notify-button:focus,
    .notify-button:active {
      background-color: #d9563a !important;
      border: none !important;
      outline: none !important;
    }

    .close-icon {
      position: absolute !important;
      right: 32px !important;
      background: none !important;
      border: none !important;
      opacity: 1 !important;
      color: #272725 !important;
      font-size: 18px !important;
      font-weight: 700 !important;
      text-shadow: none !important;
      cursor: pointer !important;
      line-height: 1 !important;
      padding: 4px 6px !important;
      transition: color 0.18s ease !important;
    }
    .close-icon:hover {
      color: #f1684a !important;
    }

    .gw-success-message {
      background-color: #f0fdf4 !important;
      border: 1px solid #bbf7d0 !important;
      border-radius: 8px !important;
      padding: 12px 16px !important;
      margin: 12px 0 !important;
      color: #166534 !important;
      font-size: 14px !important;
    }
    .success-text {
      font-weight: 500 !important;
    }
    .close-text {
      color: #166534 !important;
      font-weight: 600 !important;
      margin-left: 8px !important;
    }

    .privacy-text {
      font-size: 12px !important;
      color: #272725 !important;
      margin: 16px 0 0 !important;
      text-align: center !important;
      line-height: 1.5 !important;
    }

    .gw-branding-powered-by {
      display: none !important;
    }
  `;

  const styleIframe = (iframe) => {
    try {
      const doc = iframe.contentDocument;
      if (!doc || !doc.head || doc.readyState !== 'complete') return false;
      if (doc.getElementById('gw-theme-overrides')) return true;
      const style = doc.createElement('style');
      style.id = 'gw-theme-overrides';
      style.textContent = INJECTED_CSS;
      doc.head.appendChild(style);

      if (!doc.body.dataset.gwDismiss) {
        doc.body.dataset.gwDismiss = '1';
        doc.addEventListener('click', (e) => {
          if (!e.target.closest('.modal-container')) {
            const vueInstance = doc.defaultView && doc.defaultView.growCampaignPopUp;
            if (vueInstance && typeof vueInstance.closeModal === 'function') {
              vueInstance.closeModal();
            }
          }
        });
      }

      return true;
    } catch (e) {
      return false;
    }
  };

  const tryStyle = (iframe, attempt = 0) => {
    if (attempt > 30) return;
    if (!styleIframe(iframe)) {
      setTimeout(() => {
        tryStyle(iframe, attempt + 1);
      }, 50);
    }
  };

  const handleIframe = (iframe) => {
    iframe.addEventListener(
      'load',
      () => {
        tryStyle(iframe);
      },
      { once: true },
    );
    tryStyle(iframe);
  };

  const existing = document.getElementById(IFRAME_ID);
  if (existing) handleIframe(existing);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          const iframe = node.id === IFRAME_ID ? node : node.querySelector?.('#' + IFRAME_ID);
          if (iframe) handleIframe(iframe);
        }
      }
      if (mutation.type === 'attributes' && mutation.target.id === IFRAME_ID) {
        tryStyle(mutation.target);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
  });
})();


(function () {
  let scrollY = 0;

  window.addEventListener('scroll', () => {
    if (!document.body.style.position || document.body.style.position !== 'fixed') {
      scrollY = window.scrollY;
    }
  }, { passive: true });

  const lockScroll = () => {
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.documentElement.style.overflow = 'hidden';
  };

  const unlockScroll = () => {
    document.body.style.top = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.minHeight = '';
    document.body.style.maxHeight = '';
    document.documentElement.style.overflow = '';
    window.scrollTo({ top: scrollY, behavior: 'instant' });
  };

  const isModalVisible = () => {
    const modal = document.querySelector('.gw-modal');
    if (modal) {
      const modalStyle = window.getComputedStyle(modal);
      if (modalStyle.display !== 'none') return true;
    }
    const iframe = document.getElementById('gw-stock-fulfilled-iframe');
    if (iframe) {
      const iframeStyle = window.getComputedStyle(iframe);
      if (iframeStyle.display !== 'none') return true;
    }
    return false;
  };

  let modalOpen = false;

  const modalObserver = new MutationObserver(() => {
    const visible = isModalVisible();
    if (visible && !modalOpen) {
      modalOpen = true;
      lockScroll();
    } else if (!visible && modalOpen) {
      modalOpen = false;
      unlockScroll();
    }
  });

  modalObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
  });
})();
